import { TranslationService } from "@services/translation.service";
import { VeriDate } from "@services/veriDate.service";
import * as angular from "angular";
import "./requestVideoQueryStatus.component.scss";

export enum QueryStatus {
    None,
    GettingOnlineStatus,
    DeviceOffline,
    GettingJourneyHistory,
    GettingLatestMonthlyDaysFromCeiba,
    FailedToGetCalendar,
    GettingDailyCeibaFootage,
    FailedToGetDailyFootage,
    NoAvailableDates,
    RequestedExistingEvent,
    RequestedCustomVideo
}

interface QueryStatusConfig {
    title?: string;
    description?: string;
    icon?: string;
    showProgressBar?: boolean;
    ctaLabel?: string;
}

type QueryStatusMap = { [key: number]: QueryStatusConfig };


interface IComponentBindings {
    status?: QueryStatus;
    label?: string;
    cta?: () => void;
}

class RequestVideoQueryStatusController implements angular.IComponentController, IComponentBindings {

    // bindings
    status: QueryStatus;
    label: string;
    cta: () => void;

    showCTA: boolean;

    QueryStatus = QueryStatus;

    static $inject = ["veriDate", "translationService"];

    constructor(
        private readonly veriDate: VeriDate,
        private readonly translationService: TranslationService
    ) { }

    $onInit(): void {
        this.render();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.render();
    }

    onClickCTA(): void {
        if (!this.cta) {
            return;
        }

        this.cta();
    }

    // ---

    private render(): void {
        if (!QueryStatus[this.status]) {
            return;
        }

        this.showCTA = !!this.cta && !!this.queryStatusMap[this.status].ctaLabel;
    }

    private queryStatusMap: QueryStatusMap = {
        [QueryStatus.GettingOnlineStatus]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleGettingOnlineStatus"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionGettingOnlineStatus"),
            icon: "network_check"
        },
        [QueryStatus.DeviceOffline]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleDeviceOffline"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionDeviceOffline"),
            icon: "wifi_off",
        },
        [QueryStatus.GettingJourneyHistory]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleGatheringJourneyHistory"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionGatheringJourneyHistory"),
            icon: "event_repeat",
            showProgressBar: true
        },
        [QueryStatus.GettingLatestMonthlyDaysFromCeiba]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleGettingLatestCalendar"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionGettingLatestCalendar"),
            icon: "calendar_month",
            showProgressBar: true
        },
        [QueryStatus.FailedToGetCalendar]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleFailedToGetCalendar"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionFailedToGetCalendar"),
            icon: "wifi_off",
            ctaLabel: this.translationService.t("Common.Retry")
        },
        [QueryStatus.GettingDailyCeibaFootage]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleGettingDailyFootage"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionGettingDailyFootage"),
            icon: "today",
            showProgressBar: true
        },
        [QueryStatus.FailedToGetDailyFootage]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleFailedToGetDailyFootage"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionFailedToGetDailyFootage"),
            icon: "wifi_off",
            ctaLabel: this.translationService.t("Common.Retry")
        },
        [QueryStatus.NoAvailableDates]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleNoAvailableDates"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionNoAvailableDates"),
            icon: "event_busy"
        },
        [QueryStatus.RequestedCustomVideo]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleRequested"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionRequested"),
            icon: "cloud_done",
            ctaLabel: this.translationService.t("RequestVideoQueryStatus.RequestAnotherVideoButtonLabel")
        },
        [QueryStatus.RequestedExistingEvent]: {
            title: this.translationService.t("RequestVideoQueryStatus.QueryStatusTitleRequested"),
            description: this.translationService.t("RequestVideoQueryStatus.QueryStatusDescriptionRequested"),
            icon: "cloud_done"
        },
    }
}

export class RequestVideoQueryStatusComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            status: "<?",
            label: "<?",
            cta: "&"
        };

        this.controller = RequestVideoQueryStatusController;
        this.template = require("./requestVideoQueryStatus.component.html");
    }
}
